import React, { Component, Fragment } from 'react';
import { Query, Mutation, withApollo } from "react-apollo";
import { Formik } from 'formik';
import { gerenciarUsuariosLocaisOne, gerenciarUsuariosLocaisSave } from '../../../graphql/UsuarioLocal';
import { gerenciarGruposLocaisListQuery } from '../../../graphql/GrupoLocal';
import autoBind from 'react-autobind';
import { Button, Col, Form, Row, Container, ButtonToolbar } from 'react-bootstrap';
import Select from 'react-select';
import * as Yup from 'yup';
import InputMask from 'react-input-mask';
import Environment from '../../../environment/environment';
import Swal from 'sweetalert2';

const { Control, Group, Label } = Form;
const { Feedback } = Control;

const selectStyle = {
  control: (base, state) => ({
    ...base,
    border: '1px solid #c0c0c0',
    boxShadow: 'none',
    '&:hover': {
    border: '1px solid #c0c0c0',
    }
  })
};

const UsuarioLocalSchema = Yup.object().shape({
    nome: Yup.string().required('Nome precisa ser preenchido'),
    email: Yup.string().required('Email precisa ser preenchido'),
    data_inicio_validade: Yup.string().required('Data Início Validade precisa ser preenchido'),
    data_fim_validade: Yup.string().required('Data Fim Validade de fim precisa ser preenchido'),
});

class UsuarioLocalWidgetForm extends Component {
  constructor(props) {
    super(props);

    this.registro_inicial = {
      id: null,
      nome: "",
      email: "",
      grupo_local: {
        id: '',
        nome: '',
        membros: '',
      },
      data_inicio_validade: "",
      data_fim_validade: "",
      cargo: '',
      instituicao: '',
    }

    this.state = {
      _v: 0,
      arquivado: false,
    };

    autoBind(this);
  }

  componentDidMount() {
    let enumsQueries = [
      this.props.client.query({
        query: gerenciarGruposLocaisListQuery,
        variables: {
          archived: false,
        },
        fetchPolicy: "network-only"
      })
    ];
    Promise.all(enumsQueries).then((data) => {
      this.setState({
        enumsLoaded: true,
        enums: Object.assign({}, ...data.map(e => e.data))
      });
    });
  }

  handleSaveForm(data) {
    const { client, handleModalClose } = this.props;

    delete data.grupo_local;

    data.data_inicio_validade = Environment.localDateAndTimeStringToIso(data.data_inicio_validade);
    data.data_fim_validade = Environment.localDateAndTimeStringToIso(data.data_fim_validade);

    client.mutate({
      mutation: gerenciarUsuariosLocaisSave,
      variables: { input: Mutation.cleanupData(data) },
    }).then( data => {
      handleModalClose();
    }).catch( error => {

      data.data_inicio_validade = Environment.momentToLocalDateString(data.data_inicio_validade);
      data.data_fim_validade = Environment.momentToLocalDateString(data.data_fim_validade);      

      const errorMessage = error.graphQLErrors.map ( e => e.debugMessage).join("\n");
      Swal.fire({
        title: "Erro ao salvar usuário local",
        text: errorMessage || "",
        icon: "error",
        confirmButtonColor: "#ff0000",
        showCancelButton: false,
      });

    });
  }

  notifyChange() {
    this.setState({ _v: this.state._v + 1 });
  }

  render() {
    const { handleModalClose, id } = this.props;
    const { enums, enumsLoaded } = this.state;
    const readOnly = this.props.action === 'view';

    return (
      <Fragment>
        <Container>
          <Row className="justify-content-sm-center">
            <Col sm="12" as={Row} className="justify-content-sm-between">
              <h3>{this.props.action === "edit" ? "Editar" : this.props.action === "view" ? "Ver" : "Novo"}</h3>
              <Button onClick={() => handleModalClose()} variant="secondary" className="btn-close btn-secondary-get">Fechar</Button>
            </Col>
          </Row>
        </Container>

        <Container className="popup-content">
          <Row className="justify-content-md-center">
            <Col sm="12">
              <Query query={gerenciarUsuariosLocaisOne} skip={!id} variables={{ id }}>
                {({ error, data, loading }) => {
                  if (loading || !enumsLoaded) return "Buscando dados";
                  if (error) return `Erro ao buscar dados: ${error.message}`;

                  let formData = { ...this.registro_inicial };

                  if (data) {
                    formData = { ...data.usuarioLocalOne };
                    formData.data_inicio_validade = Environment.momentToLocalDateString(formData.data_inicio_validade);
                    formData.data_fim_validade = Environment.momentToLocalDateString(formData.data_fim_validade);
                  }

                  return (
                    <Formik
                      initialValues={{ ...formData, id: id || -1 }}
                      validationSchema={UsuarioLocalSchema}
                      onSubmit={ data => {
                          this.handleSaveForm(data);
                      }}
                    >
                      {props => {
                        const {
                          handleChange, handleSubmit, values, setFieldValue, errors, touched,
                        } = props;

                        const onChange = (event) => {
                          handleChange(event);
                          this.notifyChange();
                        }

                        return (
                          <Fragment>
                            <Form onSubmit={handleSubmit}>
                              <input id="arquivado" type="hidden" value={values.arquivado} />

                              <Row className="form-body-row">
                                <Col sm="12">

                                  {/* Nome */}
                                  <Group as={Row}>
                                    <Label column sm="2" htmlFor={"nome"}>Nome:&nbsp;&nbsp;&nbsp;<small>*</small></Label>
                                    <Col sm="4">
                                      <Control id="nome" name="nome" readOnly={readOnly} onChange={onChange} type="text" value={values.nome} isValid={!touched.nome ? undefined : !errors.nome} isInvalid={!touched.nome ? undefined : !!errors.nome} />
                                        {errors.nome && touched.nome
                                          ? (
                                              <Feedback type="invalid">{errors.nome}</Feedback>
                                            )
                                          : null}
                                    </Col>
                                  </Group>

                                  {/* Email */}
                                  <Group as={Row}>
                                    <Label column sm="2" htmlFor={"email"}>Email:&nbsp;&nbsp;&nbsp;<small>*</small></Label>
                                    <Col sm="4">
                                      <Control id="email" name="email" readOnly={readOnly} onChange={onChange} type="email" value={values.email} isValid={!touched.email ? undefined : !errors.email} isInvalid={!touched.email ? undefined : !!errors.email} />
                                        {errors.email && touched.email
                                          ? (
                                              <Feedback type="invalid">{errors.email}</Feedback>
                                            )
                                          : null}
                                    </Col>
                                  </Group>

                                  {/* Data Inicio Validade */}
                                  <Group as={Row}>
                                    <Label column sm="2" htmlFor={"data_inicio_validade"}>Data Início Validade:&nbsp;&nbsp;&nbsp;<small>*</small></Label>
                                    <Col sm="4">
                                      <InputMask className="form-control" placeholder="DD/MM/AAAA" mask="99/99/9999" maskChar=" " readOnly={readOnly} onChange={onChange} value={values.data_inicio_validade}>
                                        {(inputProps) => {
                                          return (
                                            <Control id="data_inicio_validade" name="data_inicio_validade" {...inputProps} type="text" isValid={!touched.data_inicio_validade ? undefined : !errors.data_inicio_validade} isInvalid={!touched.data_inicio_validade ? undefined : !!errors.data_inicio_validade} />
                                          );
                                        }}
                                      </InputMask>
                                      {errors.data_inicio_validade && touched.data_inicio_validade
                                        ? (
                                            <Feedback type="invalid">{errors.data_inicio_validade}</Feedback>
                                          )
                                        : null}
                                    </Col>
                                  </Group>

                                  {/* Data Fim Validade */}
                                  <Group as={Row}>
                                    <Label column sm="2" htmlFor={"data_fim_validade"}>Data Fim Validade:&nbsp;&nbsp;&nbsp;<small>*</small></Label>
                                    <Col sm="4">
                                      <InputMask className="form-control" placeholder="DD/MM/AAAA" mask="99/99/9999" maskChar=" " readOnly={readOnly} onChange={onChange} value={values.data_fim_validade}>
                                        {(inputProps) => {
                                          return (
                                            <Control id="data_fim_validade" name="data_fim_validade" {...inputProps} type="text" isValid={!touched.data_fim_validade ? undefined : !errors.data_fim_validade} isInvalid={!touched.data_fim_validade ? undefined : !!errors.data_fim_validade} />
                                          );
                                        }}
                                      </InputMask>
                                      {errors.data_fim_validade && touched.data_fim_validade
                                        ? (
                                            <Feedback type="invalid">{errors.data_fim_validade}</Feedback>
                                          )
                                        : null}
                                    </Col>
                                  </Group>

                                  <hr/>

                                  {/* Grupo Local */}
                                  <Group as={Row}>
                                    <Label column sm="2">Grupo: </Label>
                                    <Col sm="4">
                                      <Select
                                          id = {"grupo_local"}
                                          name = {"grupo_local"}
                                          className = {"gn-select"}
                                          placeholder = {"Selecione"}
                                          options = {enums.gruposLocaisList}
                                          isClearable
                                          defaultValue = {values.grupo_local}
                                          getOptionValue = { el => el.id }
                                          getOptionLabel = { el => el.nome }
                                          onChange = { selectedItem => {
                                            const val = selectedItem ? selectedItem.id : null;
                                            setFieldValue('grupo_local_id', val);
                                            this.notifyChange()
                                          }}
                                          styles = {selectStyle}
                                      />
                                      {errors.grupo_local && touched.grupo_local
                                          ? (
                                              <Feedback type="invalid">{errors.grupo_local}</Feedback>
                                          )
                                          : null}
                                    </Col>
                                  </Group>

                                  {/* Instituição */}
                                  <Group as={Row}>
                                    <Label column sm="2">Instituição:&nbsp;&nbsp;&nbsp;</Label>
                                    <Col sm="4">
                                      <Control id="instituicao" name="instituicao" readOnly={readOnly} onChange={onChange} type="instituicao" value={values.instituicao} isValid={!touched.instituicao ? undefined : !errors.instituicao} isInvalid={!touched.instituicao ? undefined : !!errors.instituicao} />
                                      {errors.instituicao && touched.instituicao
                                          ? (
                                              <Feedback type="invalid">{errors.instituicao}</Feedback>
                                          )
                                          : null}
                                    </Col>
                                  </Group>

                                  {/* Cargo */}
                                  <Group as={Row}>
                                    <Label column sm="2">Cargo:&nbsp;&nbsp;&nbsp;</Label>
                                    <Col sm="4">
                                      <Control id="cargo" name="cargo" readOnly={readOnly} onChange={onChange} type="cargo" value={values.cargo} isValid={!touched.cargo ? undefined : !errors.cargo} isInvalid={!touched.cargo ? undefined : !!errors.cargo} />
                                      {errors.cargo && touched.cargo
                                          ? (
                                              <Feedback type="invalid">{errors.cargo}</Feedback>
                                          )
                                          : null}
                                    </Col>
                                  </Group>



                                  {/* Espaço (para as opções do select quando o Fórmula está oculto) */}
                                  <br /><br /><br /><br />
                                </Col>
                              </Row>

                              {/* Botões */}
                              <Row className="form-buttons-row">
                                <Col sm="12">
                                  <Group>
                                    <ButtonToolbar>
                                      <Button onClick={() => handleModalClose()} variant="secondary" className="btn-secondary-get">Fechar</Button>
                                      {this.props.action !== 'view' ? <Button type="submit" variant="primary" className="btn-primary-get">Salvar</Button> : null}
                                    </ButtonToolbar>
                                  </Group>
                                </Col>
                              </Row>
                            </Form>
                          </Fragment>
                        )
                      }}
                    </Formik>
                  )
                }}
              </Query>
            </Col>
          </Row>
        </Container>
      </Fragment>
    );
  }
}

export default withApollo(UsuarioLocalWidgetForm);